import axios from "axios";

export default axios.create({
    baseURL:'https://app.businesstoys.in/workshop',
    // baseURL: 'http://localhost:9000/workshop',
    withCredentials: true
});